"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=convention.types.js.map